import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../hooks/Language';

import { Container } from './styles';

const Logo: React.FC = () => {

  const { language } = useLanguage();
  const [logoValue, setLogoValue] = useState("/assets/logo.svg");


  useEffect(() => {

    const validLogo = {
      ptBr: "/assets/logo.svg",
      en: "/assets/logo.svg",
      es: "/assets/logo.svg",
    }


    setLogoValue(validLogo?.[language] ? validLogo[language] : logoValue);

  }, [language])

  return (
    <Container>
      <img src={logoValue} />
    </Container>
  );
};
export default Logo;
